import React from 'react';
import PropTypes from 'prop-types';

import ksFetch from '@shared/ksFetch';

const getDisplayNameFromUrl = () => {
    const url = window.location.href;
    const displayName = url.split('@').pop();
    return displayName;
};

const AddToQueue = ({ klip, fromViewer }) => {
    const triggerKlip = async () => {
        const url = fromViewer ? "/viewers/transactions" : "/klips/queue";
        const body = fromViewer ? {
            klip_id: klip.id,
            display_name: getDisplayNameFromUrl()
        } : {
            klip_id: klip.id,
            status: 'queued'
        };

        await ksFetch(url, {
            method: 'POST',
            body: JSON.stringify({
                ...body
            })
        });
    };

    return (
        <button
            type="button"
            className="bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 flex items-center justify-center gap-2 cursor-pointer w-full"
            onClick={triggerKlip}
            data-test-id="add-to-queue-button"
        >
            <i data-feather="play" className="w-4 h-4"></i>
            Add To Queue
        </button>
    )
};

AddToQueue.propTypes = {
    klip: PropTypes.object.isRequired,
};

export default AddToQueue;
